import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { TenantStatusEnum } from '../../tenants/enums/tenant-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function tenantStatusToColor(status: TenantStatusEnum): string {
  switch (status) {
    case TenantStatusEnum.ACTIVE:
      return RecordColorEnum.GREEN;

    case TenantStatusEnum.PAST_DUE:
      return RecordColorEnum.YELLOW;

    case TenantStatusEnum.UNPAID:
      return RecordColorEnum.ORANGE;

    case TenantStatusEnum.PAUSED:
      return RecordColorEnum.RED;

    case TenantStatusEnum.CANCELED:
      return RecordColorEnum.BLUE;

    case TenantStatusEnum.TRIALING:
    default:
      return RecordColorEnum.DEFAULT;
  }
}
